/* CHW Versandschaetzung im Warenkorb (Drawer + Seite). Event-Delegation, damit es Section-Rerenders ueberlebt. */
(function () {
  if (window.__chwCartInit) return;
  window.__chwCartInit = true;

  function t(key, fallback) {
    var el = document.querySelector('[data-chw-i18n]');
    if (!el) return fallback;
    try {
      var dict = JSON.parse(el.getAttribute('data-chw-i18n'));
      return dict[key] || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function money(cents) {
    var v = (parseInt(cents, 10) || 0) / 100;
    return 'CHF ' + v.toFixed(2).replace(/\.00$/, '.–');
  }

  function fetchRates(zip, country, attempt) {
    attempt = attempt || 0;
    var url =
      '/cart/shipping_rates.json?shipping_address[zip]=' +
      encodeURIComponent(zip) +
      '&shipping_address[country]=' +
      encodeURIComponent(country);
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (r.status === 200) return r.json();
      if (r.status === 202 && attempt < 8) {
        return new Promise(function (res) {
          setTimeout(res, 700);
        }).then(function () {
          return fetchRates(zip, country, attempt + 1);
        });
      }
      return r.json().then(function (j) {
        throw new Error((j && (j.error || JSON.stringify(j))) || 'error');
      });
    });
  }

  function estimate(form) {
    if (!form) return;
    var zipEl = form.querySelector('[data-chw-zip]');
    var countryEl = form.querySelector('[data-chw-country]');
    var out = form.parentElement.querySelector('[data-chw-estimate-result]');
    var zip = (zipEl.value || '').trim();
    var country = countryEl ? countryEl.value : 'Switzerland';
    if (!zip) {
      zipEl.focus();
      return;
    }
    out.innerHTML = '<p>' + t('loading', 'Berechne…') + '</p>';
    fetchRates(zip, country)
      .then(function (j) {
        var rates = (j && j.shipping_rates) || [];
        if (!rates.length) throw new Error('empty');
        var html = '<ul>';
        rates.forEach(function (r) {
          var price = parseFloat(r.price);
          html +=
            '<li><span>' +
            r.name +
            '</span><strong>' +
            (price === 0 ? t('free', 'Gratis') : money(Math.round(price * 100))) +
            '</strong></li>';
        });
        html += '</ul>';
        out.innerHTML = html;
      })
      .catch(function () {
        out.innerHTML = '<p class="is-error">' + t('error', 'Keine Tarife gefunden.') + '</p>';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-chw-estimate]');
    if (!btn) return;
    e.preventDefault();
    estimate(btn.closest('[data-chw-estimate-form]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var zip = e.target.closest && e.target.closest('[data-chw-zip]');
    if (!zip) return;
    e.preventDefault();
    estimate(zip.closest('[data-chw-estimate-form]'));
  });
})();
